import { useTheme, useMediaQuery } from '@mui/material';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const VehicleManagement = ({ handleBack, handleClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  // const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <section
      id="vehiclemanagementsection"
      name="vehicleManagementSection"
      style={{
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: isMobile ? "0px 10px 20px 10px" : "0px 23px 20px 20px",
        boxSizing: "border-box",
        maxWidth: "100%",
        textAlign: "left",
        fontSize: isMobile ? "18px" : "22px",
        color: "#242929",
        fontFamily: '"Poppins", sans-serif',
      }}
    >
      <div
        id="vehiclemanagementcontainer"
        name="vehicleManagementContainer"
        style={{
          width: "100%",
          maxWidth: "853px",
          borderRadius: "4px",
          backgroundColor: "#fff",
          border: "1px solid #e3e3e3",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          justifyContent: "space-between",
          padding: isMobile ? "17px 15px" : "17px 20px 17px 47px",
          gap: "20px",
        }}
      >
        <div
          id="hiddeninfo"
          name="hiddenInfo"
          style={{
            height: "80px",
            width: "100%",
            position: "relative",
            borderRadius: "4px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxSizing: "border-box",
            display: "none",
            maxWidth: "100%",
          }}
        />
        <div
          id="vehicleinfoheader"
          name="vehicleInfoHeader"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: isMobile ? "center" : "flex-start",
            justifyContent: "flex-start",
            padding: isMobile ? "0" : "11px 0px 0px",
            width: isMobile ? "100%" : "auto",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <h3
            id="vehiclelistheading"
            name="vehicleListHeading"
            style={{
              margin: "0",
              position: "relative",
              fontSize: "inherit",
              lineHeight: "20px",
              fontWeight: "600",
              fontFamily: "inherit",
              zIndex: "1",
              // fontFamily: '"Poppins", sans-serif',
            }}
          >
            Vehicle Information List
          </h3>
        </div>
        <Button
          id="addvehiclebutton"
          name="addVehicleButton"
          disableElevation={true}
          variant="contained"
          onClick={handleClick}
        >
          Add Vehicle
        </Button>
      </div>
    </section>
  );
};

export default VehicleManagement;